import * as React from 'react';

export const siFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_si)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_si'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_si)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 6.66667H28V13.3333H0V6.66667Z'
                    fill='#1A47B8'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 13.3333H28V20H0V13.3333Z'
                    fill='#F93939'
                />
                <path
                    d='M2.33333 1.66667H9.66667V8.33333L6 11.6667L2.33333 8.33333V1.66667Z'
                    fill='#F93939'
                />
                <path
                    d='M2.83333 2.16667H9.16667V8.16667L6 11L2.83333 8.16667V2.16667Z'
                    fill='#1A47B8'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M4 7.66667L4.66667 5.66667L6 7L7.33333 5.66667L8 7.66667V9.33333H4V7.66667Z'
                    fill='#F1F5F9'
                />
                <path
                    d='M4 8.66667H8V9.16667H4V8.66667ZM4 9.66667H8V10.1667H4V9.66667Z'
                    fill='#1A47B8'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M5.66667 3.5L6 4.16667L6.33333 3.5L7 3.16667L6.33333 2.83333L6 2.16667L5.66667 2.83333L5 3.16667L5.66667 3.5ZM3.66667 4.5L4 5.16667L4.33333 4.5L5 4.16667L4.33333 3.83333L4 3.16667L3.66667 3.83333L3 4.16667L3.66667 4.5ZM7.66667 4.5L8 5.16667L8.33333 4.5L9 4.16667L8.33333 3.83333L8 3.16667L7.66667 3.83333L7 4.16667L7.66667 4.5Z'
                    fill='#FFCC00'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_si'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
